import { useTranslation } from 'react-i18next';

import * as Yup from 'yup';

export interface ConfirmPasswordFormValues {
	password: string;
	password_confirmation: string;
}

const schema = (): Yup.ObjectSchema<ConfirmPasswordFormValues> => {
	const { t } = useTranslation();

	return Yup.object({
		password: Yup.string()
			.required(t('validationMessages.mandatory'))
			.min(4, t('validationMessages.confirmPassword.passwordMin')),
		password_confirmation: Yup.string()
			.required(t('validationMessages.mandatory'))
			.oneOf([Yup.ref('password')], t('validationMessages.confirmPassword.passwordsMustMatch')),
	});
};

export default schema;
